import userplace from "assets/img/orders/orderDetail/userplace.png";
import Dropdown from "components/dropdown";
import { useContext, useEffect, useRef, useState } from "react";
import { FiAlignJustify, FiSearch } from "react-icons/fi";
import { MdLanguage } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { logout, updateLanguage } from "store/reducers/userSlice";
import { CONSTANTS } from "config/constant";
import { GoogleTranslateContext } from "config/GoogleTranslateProvider";
import { useProfileCTX } from "config/ProfileCTX";
import { useSocket } from "config/SocketContext";
import { useTranslation } from "react-i18next";
import Notifications from "./notifications";

const Navbar = (props) => {
  const { i18n, t } = useTranslation();
  const { onOpenSidenav, brandText, open } = props;

  const dispatch = useDispatch();
  const userDataString = localStorage.getItem("userData");
  const userData = JSON.parse(userDataString);
  const language = useSelector((state) => state?.user?.language);
  // const userProfile = useSelector((state) => state?.user?.profileData);
  const { profileData, setProfileData } = useProfileCTX();
  const { connect, disconnect, isOnline, socket } = useSocket();

  // const { changeLanguage, currentLanguage } = useContext(GoogleTranslateContext);
  const {
    changeLanguage,
    currentLanguage,
    registerLanguageSelector,
    setCurrentLanguage,
  } = useContext(GoogleTranslateContext);
  const selectorRef = useRef(null);

  //   const { languages, setLanguages, scriptLoaded, error } = useContext(
  //     GoogleTranslateContext
  //   );

  useEffect(() => {
    if (selectorRef.current) {
      registerLanguageSelector(selectorRef.current);
    }
  }, [registerLanguageSelector]);

  // const handleLanguageChange = (lang) => {
  //   console.log("Changing language to:", lang);
  //   if (lang === "arabic") {
  //     const rootDiv = document.getElementById('root');
  //     rootDiv.setAttribute('dir', "rtl");
  //     console.log("Changing language to:..", lang);
  //     dispatch(updateLanguage("arabic"))
  //     i18n.changeLanguage(lang);

  //   } else if(lang === "english") {
  //     const rootDiv = document.getElementById('root');
  //     rootDiv.setAttribute('dir', "ltr");    }
  //     dispatch(updateLanguage("english"))
  //     i18n.changeLanguage(lang);

  // };
  // const handleLanguageChange = (langCode) => {
  //   console.log("Changing language to:", langCode);
  //   const rootDiv = document.getElementById('root');
  //   if (langCode === "ar") {
  //     rootDiv.setAttribute('dir', "rtl");
  //     dispatch(updateLanguage("arabic"));
  //   } else if (langCode === "en") {
  //     rootDiv.setAttribute('dir', "ltr");
  //     dispatch(updateLanguage("english"));
  //   }
  //   i18n.changeLanguage(langCode);
  // };

  const handleLanguageChange = (lang) => {
    // localStorage.setItem("selectedLanguage", lang);

    console.log("Changing language to:", lang);
    if (lang === "ar") {
      const rootDiv = document.getElementById("root");
      rootDiv.setAttribute("dir", "rtl");
      console.log("Changing language to:..", lang);
      dispatch(updateLanguage("ar"));
      // changeLanguage("ar");
      i18n.changeLanguage(lang);
    } else if (lang === "en") {
      const rootDiv = document.getElementById("root");
      rootDiv.setAttribute("dir", "ltr");
      dispatch(updateLanguage("en"));
      // changeLanguage("en");
      i18n.changeLanguage(lang);
    }
    console.log("i18", i18n);
  };
  // useEffect(() => {
  //   const storedLang = localStorage.getItem("selectedLanguage") || "en";
  //   setCurrentLanguage(storedLang);

  //   // Ensure the direction is correctly applied
  //   // document.documentElement.setAttribute("dir", storedLang === "ar" ? "rtl" : "ltr");
  //   if (storedLang === "ar") {
  //     dispatch(updateLanguage("ar"));
  //     const rootDiv = document.getElementById("root");
  //     rootDiv.setAttribute("dir", "rtl");
  //   } else {
  //     dispatch(updateLanguage("en"));

  //     const rootDiv = document.getElementById("root");
  //     rootDiv.setAttribute("dir", "ltr");
  //   }
  // }, []);
  // useEffect(() => {
  //   if (scriptLoaded) {
  //     const select = document.querySelector(".goog-te-combo");
  //     if (select) {
  //       select.addEventListener("change", (e) => {
  //         setLanguages(e.target.value);
  //         console.log("Language changed to:", e.target.value);
  //       });
  //     }
  //   }
  // }, [scriptLoaded, setLanguages]);

  return (
    <nav className="sticky  z-40 flex flex-row flex-wrap items-center justify-between rounded-xl bg-white/10 p-2 backdrop-blur-xl dark:bg-[#0b14374d]">
      <div className="ml-[6px]">
        <div className="h-6 w-[224px] pt-1">
          <a
            className="text-sm font-normal text-navy-700 hover:underline dark:text-white dark:hover:text-white"
            href=" "
          >
            {t("Pages")}
            <span className="mx-1 text-sm text-navy-700 hover:text-navy-700 dark:text-white">
              {" "}
              /{" "}
            </span>
          </a>
          <Link
            className="text-sm font-normal capitalize text-navy-700 hover:underline dark:text-white dark:hover:text-white"
            to="#"
          >
            {brandText}
          </Link>
        </div>
        <p className="shrink pt-5 text-[33px] capitalize text-navy-700 dark:text-white">
          <Link
            to="#"
            className="font-bold capitalize hover:text-navy-700 dark:hover:text-white"
          >
            {brandText}
          </Link>
        </p>
      </div>

      <div className="relative mt-[3px] flex h-[61px] w-[355px] flex-grow items-center justify-around gap-2 rounded-full bg-white px-2 py-2 shadow-xl shadow-shadow-500 dark:!bg-navy-800 dark:shadow-none md:w-[365px] md:flex-grow-0 md:gap-1 xl:w-[365px] xl:gap-2">
        <div className="flex h-full items-center rounded-full bg-lightPrimary text-navy-700 dark:bg-navy-900 dark:text-white xl:w-[225px]">
          <p className="pl-3 pr-2 text-xl">
            <FiSearch className="h-4 w-4 text-gray-400 dark:text-white" />
          </p>
          <input
            type="text"
            placeholder={t("Search...")}
            class="block h-full w-full rounded-full bg-lightPrimary text-sm font-medium text-navy-700 outline-none placeholder:!text-gray-400 dark:bg-navy-900 dark:text-white dark:placeholder:!text-white sm:w-fit"
          />
        </div>
        <span
          className="flex cursor-pointer text-xl text-gray-600 dark:text-white xl:hidden"
          onClick={() => {
            onOpenSidenav();
          }}
        >
          <FiAlignJustify className="h-5 w-5" />
        </span>

        <Notifications />
        <Dropdown
          ref={selectorRef}
          className="notranslate"
          button={<MdLanguage />}
          children={
            <div className="flex w-56 flex-col justify-start rounded-[20px] bg-white bg-cover bg-no-repeat shadow-xl shadow-shadow-500 dark:!bg-navy-700 dark:text-white dark:shadow-none">
              <div className="h-px w-full bg-gray-200 dark:bg-white/20 " />

              <div className="flex flex-col p-4">
                <p
                  onClick={() => {
                    handleLanguageChange("ar");
                    // changeLanguage("ar");
                    dispatch(updateLanguage("ar"));
                  }}
                  className="mt-3 cursor-pointer text-sm text-gray-800 dark:text-white hover:dark:text-white"
                >
                  Arabic
                </p>

                <p
                  onClick={() => {
                    handleLanguageChange("en");
                    // changeLanguage("en");

                    dispatch(updateLanguage("en"));
                  }}
                  className="mt-3 cursor-pointer text-sm text-gray-800 dark:text-white hover:dark:text-white"
                >
                  English
                </p>
              </div>
            </div>
          }
          classNames={`${
            language === "ar"
              ? "py-2 top-8 left-0 -start-[180px] w-max"
              : `py-2 top-8 -left-[180px] w-max`
          } `}
        />

        {/* Profile & Dropdown */}
        <Dropdown
          button={
            process.env.REACT_APP_APPLICATION_NAME === "admin" ? (
              <img
                className="h-10 w-10 rounded-full object-cover"
                src={
                  profileData?.profile_image?.[0]?.file_url
                    ? CONSTANTS?.IMG_DIRECTORY +
                      profileData?.profile_image?.[0]?.file_url
                    : CONSTANTS?.IMG_DIRECTORY +
                      userData?.data?.profile_image?.[0]?.file_url
                }
                alt="Profile"
              />
            ) : process.env.REACT_APP_APPLICATION_NAME === "laundry" ? (
              <img
                className="h-10 w-10 rounded-full object-cover"
                // src={userplace}
                src={
                  profileData?.profile_image?.[0]?.file_url
                    ? CONSTANTS?.IMG_DIRECTORY +
                      profileData?.profile_image?.[0]?.file_url
                    : userplace
                }
                alt="Profile"
              />
            ) : process.env.REACT_APP_APPLICATION_NAME === "provider" ? (
              <img
                className="h-10 w-10 rounded-full object-cover"
                src={
                  profileData?.profile_image?.[0]?.file_url
                    ? CONSTANTS?.IMG_DIRECTORY +
                      profileData?.profile_image?.[0]?.file_url
                    : userplace
                }
                alt="Profile"
              />
            ) : (
              ""
            )
          }
          children={
            <div className="flex w-56 flex-col justify-start rounded-[20px] bg-white bg-cover bg-no-repeat shadow-xl shadow-shadow-500 dark:!bg-navy-700 dark:text-white dark:shadow-none">
              <div className="p-4">
                <div className="flex items-center gap-2">
                  <p className="text-sm font-bold text-navy-700 dark:text-white">
                    👋 Hey,{" "}
                    {process.env.REACT_APP_APPLICATION_NAME === "admin"
                      ? (profileData?.first_name
                          ? profileData?.first_name
                          : userData?.data?.first_name) +
                        " " +
                        (profileData?.last_name
                          ? profileData?.last_name
                          : userData?.data?.last_name)
                      : process.env.REACT_APP_APPLICATION_NAME === "laundry"
                      ? profileData?.laundry_name
                      : process.env.REACT_APP_APPLICATION_NAME === "provider"
                      ? profileData?.store_name
                      : ""}
                  </p>
                </div>
              </div>
              <div className="h-px w-full bg-gray-200 dark:bg-white/20 " />

              <div className="flex flex-col p-4">
                <Link
                  to={"/admin/profile"}
                  className="text-sm text-gray-800 dark:text-white hover:dark:text-white"
                >
                  Profile Settings
                </Link>
                {/* <a
                  href=" "
                  className="mt-3 text-sm text-gray-800 dark:text-white hover:dark:text-white"
                >
                  Newsletter Settings
                </a> */}
                {/* <p
                  onClick={() => {
                    handleLanguageChange("arabic");
                  }}
                  href=" "
                  className="mt-3 cursor-pointer text-sm text-gray-800 dark:text-white hover:dark:text-white"
                >
                  Arbic
                </p> */}
                <Link
                  to="/auth/sign-in"
                  className="mt-3 text-sm font-medium text-red-500 transition duration-150 ease-out hover:text-red-500 hover:ease-in"
                  onClick={() => {
                    localStorage.clear();
                    dispatch(logout(userData));
                    setProfileData("");
                  }}
                >
                  Log Out
                </Link>
              </div>
            </div>
          }
          classNames={`${
            language === "ar"
              ? "py-2 top-8 left-0 -start-[180px] w-max"
              : `py-2 top-8 -left-[180px] w-max`
          } `}
        />
      </div>
    </nav>
  );
};

export default Navbar;
